import axios from "axios";

class GetNewsService {

    KEY = '8e7fbc299a2f25159180a0dc8e3e29a6';

    async getNews(lan, query){
        const url = `https://gnews.io/api/v4/search?q=${query}&lang=${lan}&apikey=${this.KEY}`;
        return axios.get(url);
    }

}

export default new GetNewsService();